import axiosInstance from "../../../interceptors/axiosInstance";
import { EliminarMandatarioDto, Mandatario } from "../models/mandatario";
import { ParticipanteRequest } from "../models/participantes";
import axios, { AxiosResponse } from "axios";

const getMandatario = async (data: ParticipanteRequest) => {

  const axiosResponse: Promise<AxiosResponse> = axiosInstance.get(`siscred-api-participantes/v1/participante-mandatario/obtener-mandatario`, {
    params: {
      rut: data.rut,
      mutuoId: data.mutuoId
    }
  });

  return axiosResponse;

}


const updateMandatario = async (data: Mandatario) => {

  const axiosResponse = axiosInstance.put(`siscred-api-participantes/v1/participante-mandatario/actualizar/mandatario/${data.mutuoid}`, data);

  return axiosResponse;
}


const createMandatario = async (data: Mandatario) => {

  const axiosResponse = axiosInstance.post(`siscred-api-participantes/v1/participante-mandatario/nuevo-mandatario`, data);

  return axiosResponse;
}

const deleteMandatario = async (data: EliminarMandatarioDto) => {
  const axiosResponse = await axiosInstance.delete(`siscred-api-participantes/v1/participante-mandatario/eliminar/mandatario/${data.idMutuo}`, {
    params: {
      idMutuo: data.idMutuo,
      rut: data.rut
    }
  });

  return axiosResponse;
};


export {
  getMandatario,
  updateMandatario,
  createMandatario,
  deleteMandatario
}